import { Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { Navigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import AdminLayout from '../../layouts/AdminLayout/AdminLayout';
import OpenPacket from './ClaimLink';

function OwnerGate() {
    const { t } = useTranslation('common');
    const { authInitializing, isAuthenticated } = useAuth();

    if (authInitializing) {
        return <Spin fullscreen size="large" tip={t('loading.session')} />;
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" replace state={{ from: '/red-packet' }} />;
    }

    return (
        <div className="app-shell">
            <AdminLayout />
        </div>
    );
}

function RedPacketEntry() {
    const [params] = useSearchParams();
    const token = params.get('token') || '';

    if (token) {
        return <OpenPacket token={token} status={params.get('status') || ''} />;
    }

    return <OwnerGate />;
}

export default RedPacketEntry;
